import { Override } from 'src/app/types/shared';
import { TrackMode, ZArt, ZType } from './zaehler.enums';

export interface ToleranzenAktivOptions {
  isSR100: boolean;
  isSRG: boolean;
}

export interface ZählerName extends ToleranzenAktivOptions {
  ID?: number;
  /** @required @unique */
  Code: string;
  Bezeichnung: string;
  /** SkizzenName */
  Bild: string;
  HasHelper?: boolean;
  Track0?: TrackMode;
  Track1?: TrackMode;
  Track2?: TrackMode;
  Track3?: TrackMode;
}

export const TOL_AKTIV = {
  aktivSRlimm: false,
  aktivSR100: false,
  aktivSRG: false,
};
export const TOL_PLUS = {
  SRlimplus: 0,
  SR100plus: 0,
  SRGplus: 0,
};
export const TOL_MINUS = {
  SRlimminus: 0,
  SR100minus: 0,
  SRGminus: 0,
};

export type ToleranzenMinus = {
  [key in keyof typeof TOL_MINUS]: (typeof TOL_MINUS)[key];
};

export type ToleranzenPlus = {
  [key in keyof typeof TOL_PLUS]: (typeof TOL_PLUS)[key];
};

type ToleranzenAktiv = {
  [key in keyof typeof TOL_AKTIV]: (typeof TOL_AKTIV)[key];
};

export interface Toleranzen extends ToleranzenMinus, ToleranzenPlus, ToleranzenAktiv {}

export interface ZählerWert extends Toleranzen {
  ID?: number;
  SZAEHNID?: number;
  I_SORT: number;
  /** @required @unique within SZAEHNID*/
  Code: string;
  Soll: number;
  Bezeichnung: string;
  ZArt: ZArt; // ENUM
  ZType: ZType; // ENUM
  isHeader?: boolean;
  ZEinheit: number; // id from szaeeh
  Einheit?: string;
  SGenau: Genauigkeit;
  TGenau: Genauigkeit;
  Track: 0 | 1 | 2 | 3;
}

export type ZählerWertModel = Override<ZählerWert, { Soll: number | 'Ja' }>;

export type Genauigkeit = 0 | 1 | 2 | 3; // Zahl der Dezimalwerte

export interface ToleranzenBezeichnungen {
  //#region Tol SR100
  TEXT_100_m: string;
  TEXT_100_p: string;
  TEXT_100_A: string;
  TEXT_100_S: string;
  COLOR_100: string;
  //#endregion
  //#region Tol SRLim
  TEXT_L_m: string;
  TEXT_L_p: string;
  TEXT_L_A: string;
  TEXT_L_S: string;
  COLOR_L: string;
  //#endregion
  //#region Tol SRG
  TEXT_G_m: string;
  TEXT_G_p: string;
  TEXT_G_A: string;
  TEXT_G_S: string;
  COLOR_G: string;
  //#endregion
}

export interface ZählerEinheit {
  ID?: number;
  Code: string;
  Bezeichnung: string;
  OTYPID: number;
}

export interface ZählerPrüfung {
  OPRUEFID?: number;
  P_Datum?: string;
  Column_Datum?: string;
  P_Bemerkung: string;
  /** Messungsdatum */
  P_ZDatum: string;
  /** Messender */
  P_ZUser: string;
  /** Messgerät */
  M_Device: string;
}

export interface MesswertErfassung {
  ID?: number;
  /** @see ZählerWert.Code */
  Bezeichnung: string;
  Ist: number | 'Ja' | 'Nein' | 'n.g.';
  Bemerkung: string;
  Ausfall: string;
}

export interface MesswertEintrag extends MesswertErfassung {
  /** @see ZählerWert */
  Soll: number | 'Ja';
  SRlimplus: number;
  SRlimminus: number;
  SR100plus: number;
  SR100minus: number;
  SRGplus: number;
  SRGminus: number;
  isHeader: boolean;

  /** @see ZählerWert.ZArt */
  ZTYP: 0 | 1 | 6;

  /** @see ZählerWert.Code + @see ZählerWert.Bezeichnung */
  INFO: string;
}

export interface MessungGroup {
  pruefung: ZählerPrüfung;
  messwerte: MesswertErfassung[];
  unsaved?: boolean;
}

export interface MessungModel {
  pruefung: ZählerPrüfung;
  messwerte: MesswertEintrag[];
}

export interface MessungGroupÜbersicht {
  pruefung: Partial<ZählerPrüfung>;
  messwerte: MesswertEintrag[];
}

export type MessungÜbersicht = {
  Bezeichnung: MesswertErfassung['Bezeichnung'];
  Soll: MesswertEintrag['Soll'];
  SRlimplus: MesswertEintrag['SRlimplus'];
  SRlimminus: MesswertEintrag['SRlimminus'];
  SR100plus: MesswertEintrag['SR100plus'];
  SR100minus: MesswertEintrag['SR100minus'];
  SRGplus: MesswertEintrag['SRGplus'];
  SRGminus: MesswertEintrag['SRGminus'];
} & { [date: string]: MesswertErfassung['Ist'] | string | number };

export interface ZaehlerObjektInfo {
  OSTAMMID: number;
  OPRUEFID: number;
  mID?: number;
}
